import { render } from "./UserByShifts.vue?vue&type=template&id=5a788c7c&scoped=true"
import script from "./UserByShifts.vue?vue&type=script&lang=js"
export * from "./UserByShifts.vue?vue&type=script&lang=js"

import "./UserByShifts.vue?vue&type=style&index=0&id=5a788c7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a788c7c"]])

export default __exports__